


























































































































































/* tslint:disable:only-arrow-functions*/

import {Component, Vue} from 'vue-property-decorator';
import getFileSizeHumanReadable from '@/util/file-size';
import AnimatedInput from '@/components/AnimatedInput.vue';
import AnimatedTextArea from '@/components/AnimatedTextarea.vue';
import LoadingButton from '@/components/LoadingButton.vue';
import Browsercheck from '@/components/Browsercheck.vue';
import {Action, Getter, Mutation} from "vuex-class";
import * as Sentry from '@sentry/browser';
import featureFlags from "@/util/featureFlags";
import EncryptedFile from "@/models/EncryptedFile";
import TransferInteraction from "@/models/TransferInteraction";
import InteractionAdapter from "@/adapters/interaction";
import EncryptedTransferInteraction from "@/models/EncryptedTransferInteraction";
import KeyUtility from "@/util/keyUtility";
import Metadata from "@/models/Metadata";
import dayjs from "@/util/dayjs";
import {Modal} from "bootstrap-vue";

@Component({
    components: { AnimatedInput, LoadingButton, Browsercheck, AnimatedTextArea },
})
export default class Download extends Vue {

    @Getter isLoggedIn!: boolean;
    @Getter loggedInName!: string;
    @Getter showDownloadLoading!: boolean;
    @Getter showDownloadAskForPassword!: boolean;
    @Getter showDownloadDetails!: boolean;
    @Getter showDownloadProgress!: boolean;
    @Getter showDownloadSuccess!: boolean;
    @Getter showDownloadError!: boolean;
    @Getter downloadProgress!: number;
    @Getter downloadErrorMessage!: string;
    @Getter downloadMetadata!: Metadata | null;

    @Action onlyDownloadMetadata!: ({id, urlMaterial}: {id: string, urlMaterial: string}) => Promise<any>;
    @Action decryptMetadata!: ({urlMaterial, password}: {urlMaterial: string, password: string}) => Promise<any>;
    @Action downloadFile!: (fileIdx: number) => Promise<any>;
    @Action prepareServiceWorker!: () => Promise<any>;
    @Action downloadFileViaSW!: () => Promise<any>;

    animateProgress: boolean = true;
    urlMaterial: string = "";
    password: string = "";
    btnDisabled: boolean = true;

    enteredName: string = "";

    fileApprovalState: Array<boolean | undefined> = [];

    encryptedInteractions: EncryptedTransferInteraction[] = []; //Everything the server gave us
    decryptedInteractions: TransferInteraction[] = []; //Filtered down to comments

    useOnlyServiceWorker: boolean = false;

    currentFileIdx: number = 0;
    commentText: string = "";

    async created() {

        const id = this.$route.params.id;
        let keyMaterial = this.$route.hash;

        if (keyMaterial === '') {
            this.$swal('Ein Fehler trat auf', 'Der Link war nicht korrekt.', 'error');
        }

        if (keyMaterial.startsWith('#')) {
            keyMaterial = keyMaterial.substring(1); //remove leading #
        }
        this.urlMaterial = keyMaterial;

        this.onlyDownloadMetadata({ id, urlMaterial: keyMaterial }).then(() => {
            this.$log.debug("Enabling button");
            this.btnDisabled = false;
            this.downloadEncryptedInteractions();
        }).catch((error) => {
          this.$log.error("An error occured while downloading metadata", error);
        });
    }

    get showAds() {
      return !featureFlags.usersEnabled;
    }

  async downloadEncryptedInteractions(): Promise<void> {
    const id = this.$route.params.id;
    try {
      const adapter = new InteractionAdapter();
      const serverFetched: EncryptedTransferInteraction[] = await adapter.getInteractionsForUpload(id);
      this.encryptedInteractions = serverFetched;
    } catch (e) {
      this.$log.error("Failed to download interactions of upload", e);
    }
  }

    async filterAndDecryptComments(): Promise<void> {
      let decryptedInteractions: TransferInteraction[] = [];

      if (this.downloadMetadata && this.downloadMetadata.interactionConfiguration && this.downloadMetadata.interactionConfiguration.symmetricInteractionKey) {
        const interactionKey: CryptoKey = await KeyUtility.loadKeyFromBase64(this.downloadMetadata.interactionConfiguration.symmetricInteractionKey);

        for (const encryptedInteraction of this.encryptedInteractions) {
          const decrypted = await TransferInteraction.FROM_ENCRYPTED(encryptedInteraction, interactionKey);
          decryptedInteractions.push(decrypted);
        }

        decryptedInteractions = decryptedInteractions.filter((interaction: TransferInteraction) => {
          return interaction.type === "comment" && interaction.fileIdx === this.currentFileIdx;
        });

      }
      this.decryptedInteractions = decryptedInteractions;
    }

    get sortedComments(): TransferInteraction[] {
      return this.decryptedInteractions.sort((a, b) => {
        if (a.created === b.created) {
          return 0;
        }
        return dayjs(a.created).isAfter(dayjs(b.created)) ? -1 : 1;
      });
    }

  sizeHumanReadable(file: EncryptedFile): string {
    return getFileSizeHumanReadable(file.size);
  }

  get approvalIsEnabled(): boolean {
    return this.$store.state.download.interactionConfig && this.$store.state.download.interactionConfig.approvalEnabled;
  }

  get twoWayCommentsAreEnabled(): boolean {
    return this.$store.state.download.interactionConfig && this.$store.state.download.interactionConfig.enableComments === "twoway";
  }

  async initiateDownload(fileIdx: number) {
      this.$log.debug(`Downloading file #${fileIdx}`);

      //Check if we need to collect a name:
      const id = this.$route.params.id;

      if (this.$store.state.download.interactionConfig && this.$store.state.download.interactionConfig.needsNameEntered ) {

        const input = document.createElement("input");
        input.value = this.enteredName;
        input.placeholder = "Wie lautet Dein Name?";
        input.type = 'text';
        input.className = 'swal-content__input';

        //@ts-ignore
        await this.$swal({
          text: 'Bitte gib  zum Download Deinen Namen an.',
          content: input,
          buttons: {
            confirm: {
              value: "",
            },
          },
        });

        this.enteredName = input.value.trim();
        if (this.enteredName === "") {
          this.$toast.error("Name ist notwendig");
          return;
        }

        //Create interaction to record download:
        const interaction = TransferInteraction.DOWNLOAD(fileIdx, this.enteredName);
        const interactionKey = this.$store.state.download.interactionConfig.symmetricInteractionKey;
        const encrypted = await interaction.encryptWithSerializedKey(interactionKey);
        const adapter = new InteractionAdapter();
        void adapter.addInteraction(id, encrypted);
      }

      //Check if we can do this in RAM:
      const encFile: EncryptedFile = this.$store.state.download.receivedFiles[fileIdx];

      if (!this.checkForBrowserSupport(encFile.size) || this.useOnlyServiceWorker) {
        this.startSwDownload(fileIdx);
      } else {
        this.startDownload(fileIdx);
      }
  }

  async openInteractionModal(fileIdx: number) {
      //TODO: Loading but even with 20 Comments this is super fast...?
    this.currentFileIdx = fileIdx;
    await this.filterAndDecryptComments();
    (this.$refs.interactionmodal as Modal).show();
  }

  closeInteractionModal() {
    (this.$refs.interactionmodal as Modal).hide();
    this.decryptedInteractions = [];
    this.commentText = "";
  }

  formatDateString(dateString: string): string {
    const date = dayjs(dateString);
    return date.format('dddd, DD. MMMM YYYY [um] HH:mm');
  }

    startDownload(fileIdx: number) {
        this.downloadFile(fileIdx);
    }

    startSwDownload(fileIdx: number) {
        this.prepareServiceWorker().then(() => {

            const useFrame: boolean = true;

            this.downloadFileViaSW();
            if (useFrame) {
                const iframe = document.createElement('iframe');
                iframe.hidden = true;
                iframe.src = this.serviceWorkerDownloadLink(fileIdx);
                iframe.name = 'iframe';
                document.body.appendChild(iframe);

            } else {
                /*
                const options = 'width=200,height=100';
                window.open(this.serviceWorkerDownloadLink, 'popup', options); */
                const a = document.createElement('a'); //Works in modern firefox
                a.href = this.serviceWorkerDownloadLink(fileIdx);
                a.setAttribute('download', '');
                document.body.appendChild(a);
                a.click();
            }


        });
    }

    get browserSupport() {
        return this.$store.state.download.browserSupportsBlobsize ||
            (this.$store.state.serviceWorkerIsSupported && this.$store.state.serviceWorkerIsRegistered);
    }

    get browserDoesNotSupportWebworkers() {
        return !this.$store.state.serviceWorkerIsSupported;
    }

    get homepageLink() {
        return featureFlags.frontendBaseUrl;
    }

    get receivedFiles(): EncryptedFile[] {
        return this.$store.state.download.receivedFiles;
    }

    get downloadViaServiceWorker() {
        return this.$store.state.serviceWorkerIsRegistered;
    }

    serviceWorkerDownloadLink(fileIdx: number) {
        return `${location.protocol}//${location.host}/fetchfilefromworker/${fileIdx}`;
    }

    async continueAfterPassword() {

        return this.decryptMetadata({urlMaterial: this.urlMaterial, password: this.password})
            .then((result: boolean) => {
                if (!result) {
                    this.password = "";
                    this.$swal('Falsches Passwort!', 'Bitte gib das Passwort richtig an.', 'error');
                } else {
                    //this.$store.dispatch("downloadFile");
                    if (this.downloadViaServiceWorker) {
                        this.prepareServiceWorker().then(() => {
                            this.btnDisabled = false;
                        }).catch((e) => {
                            this.$log.error("Preparing service worker failed", e);
                            Sentry.captureException(e);
                        });
                    }
                }
            })
            .catch((e) => {
                this.password = "";
                this.$swal('Ein Fehler trat auf', 'Bitte nochmal versuchen', 'error');
                Sentry.captureException(e);
            });

    }

  fileProgress(filename: string) {
      const allFileProgresses = this.$store.state.download.downloadProgressPerFile;
      return allFileProgresses[filename] || 0;
  }

  checkForBrowserSupport(filesize: number): boolean {
    let result = false;
    try {
      let arr: Uint8Array = new Uint8Array(filesize);
      let blob: Blob = new Blob([arr]);
      const works = blob.size === filesize;
      if (works) {
        Vue.$log.info(`Test successful. Constructed blob with ${blob.size} Bytes`);
        result = true;
      } else {
        Vue.$log.error(`Test failed. Constructed blob with ${blob.size} Bytes, Array had ${filesize}`);
        result = true;
      }
      //Overwrite reference, so it gets freed
      blob = new Blob();
      arr = new Uint8Array();
    } catch (e) {
      Vue.$log.info(`Test failed. Constructing blob with ${filesize} Bytes failed with exception`, e);
      result = false;
      Sentry.captureException(e);
    }
    return result;
  }

  async askForFileApproval(fileIdx: number) {
    const input = document.createElement("input");
    input.value = this.enteredName;
    input.placeholder = "Wie lautet Dein Name?";
    input.type = 'text';
    input.className = 'swal-content__input';

    //@ts-ignore
    const clickResult = await this.$swal("Möchtest Du für Datei die Freigabe erteilen?", {
      content: input,
      buttons: {
        no: {
          text: "Ablehnen",
          value: "no",
          className: "btn btn-danger",
        },
        stop: {
          text: "Abbrechen",
          value: "cancel",
          className: "btn btn-secondary",
        },
        yes: {
          text: "Freigeben",
          value: "yes",
          className: "btn btn-success",
        },
      },
    });

    if (clickResult === "cancel") {
      return;
    }

    const result: boolean = clickResult === "yes";
    this.enteredName = input.value.trim();
    if (this.enteredName === "") {
      this.$toast.error("Name ist notwendig");
      return;
    }

    await this.approveFile(fileIdx, this.enteredName, result);
    Vue.set(this.fileApprovalState, fileIdx, result);
    this.$toast.success("Freigabe abgesendet");

  }

  async approveFile(fileIdx: number, name: string, result: boolean) {
    const id = this.$route.params.id;
    const interaction = TransferInteraction.APPROVAL(fileIdx, name, result);
    const interactionKey = this.$store.state.download.interactionConfig.symmetricInteractionKey;
    const encrypted = await interaction.encryptWithSerializedKey(interactionKey);
    const adapter = new InteractionAdapter();
    await adapter.addInteraction(id, encrypted);
  }

  async handleCommentPostClicked() {
      const name = this.enteredName.trim();
      const content = this.commentText.trim();
      if (name === "" || content === "") {
        this.$toast.error("Name und Kommentar sind notwendig");
        return;
      }
      await this.postComment(this.currentFileIdx, name, content);
      this.$toast.success("Kommentar gesendet!");
      this.closeInteractionModal();
  }

  async postComment(fileIdx: number, name: string, comment: string) {
    const id = this.$route.params.id;
    const interaction = TransferInteraction.COMMENT(fileIdx, name, comment);
    const interactionKey = this.$store.state.download.interactionConfig.symmetricInteractionKey;
    const encrypted = await interaction.encryptWithSerializedKey(interactionKey);
    const adapter = new InteractionAdapter();
    await adapter.addInteraction(id, encrypted);
    this.$nextTick(() => {
      this.downloadEncryptedInteractions();
    });
  }

  goToProSite() {
    this.$router.push('/pro');
  }

}
